import { z } from "zod";
import contract from "@/generated/ui-authorization.json";
import { isFeatureVisible } from "@/lib/feature-visibility";

export const RoutePolicySchema = z.object({
  path: z.string(),
  access: z.enum(["public", "session", "capability"]),
  capability: z.string().optional(),
  feature: z.string().optional(),
  screens: z.array(z.string()),
  reason: z.string().optional(),
});
export type RoutePolicy = z.infer<typeof RoutePolicySchema>;
export const ROUTE_POLICIES = z.array(RoutePolicySchema).parse(contract.routes);

// Segmentos completos: /admin não autoriza uma rota nova por coincidência de prefixo.
export function policyForPath(path: string, policies: readonly RoutePolicy[] = ROUTE_POLICIES) {
  const parts = path.replace(/\/$/, "").split("/");
  return policies.find((policy) => {
    const pattern = policy.path.replace(/\/$/, "").split("/");
    return (
      pattern.length === parts.length &&
      pattern.every((part, index) =>
        part.startsWith("$") ? !!parts[index] : part === parts[index],
      )
    );
  });
}

export function canEnterRoute(
  path: string,
  capabilities: ReadonlySet<string>,
  features: Record<string, boolean>,
  policies: readonly RoutePolicy[] = ROUTE_POLICIES,
): boolean {
  const policy = policyForPath(path, policies);
  if (!policy) return false;
  // O contrato classifica os scores como analytics; sua UI também depende da gamificação.
  if (policy.path === "/admin/user-scores" && !isFeatureVisible("gamification")) return false;
  if (
    policy.access === "capability" &&
    (!policy.capability || !capabilities.has(policy.capability))
  )
    return false;
  return (
    !policy.feature || (isFeatureVisible(policy.feature) && features[policy.feature] !== false)
  );
}
